import React from 'react';
import DateHelper from '../../DateHelper/DateHelper';
import Colorpicker from '../../Colorpicker/Colorpicker';

export default class ReportPresenterDetails extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div className="panel-body">
        {this.renderGeneralInfo()}
        {this.renderXAxisDetails()}
        {this.renderYaxisDetails()}
      </div>
    );
  };

  renderGeneralInfo() {
    return(
      <div className="row" style={{paddingLeft: 15}}>
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('code')}`}</label>
            <p>{this.props.report_details.code}</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>{I18n.t('name')}</label>
            <p>{this.props.report_details.name}</p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label>{I18n.t('chart_type')}</label>
            <p>{I18n.t(this.props.report_details.chart_type.name)}</p>
          </div>
        </div>
      </div>
    );
  };

  renderXAxisDetails() {
    return(
      <div className="panel">
        <div className="panel-default container">
          <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: '10px', paddingTop: '0px', paddingLeft: '0px', marginTop: '0px', marginBottom: '10px' }}>{I18n.t('horizontal_axis_details')}</h5>
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label>{I18n.t('label')}</label>
                  <p>{this.props.report_details.x_label}</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                <label>{I18n.t('data_sources_name_type')}</label>
                  <p>{this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis').data_type.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}</p>
                </div>
              </div>
              {
              this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis').data_source.system_data && this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis').data_type === 'date'
                ?
                <div className="col-md-2">
                  <div className="form-group">
                    <label>{I18n.t('group_by')} <span className="ss-help help" title={I18n.t('default_x_range_helper_text')}></span></label>
                    <p>{I18n.t(this.props.report_details.x_grouping)}</p>
                  </div>
                </div>
                :
                null
              }
              {
              this.props.report_details.x_range === 'specific_dates'
                ?
                <div className="col-md-3">
                  <div>
                    <label>{`${I18n.t('begins')}`}</label>
                    <p>{DateHelper.printDateToScreen(this.props.report_details.start_date, this.props.date_format)}</p>
                  </div>
                  <div>
                    <label>{`${I18n.t('ends')}`}</label>
                    <p>{DateHelper.printDateToScreen(this.props.report_details.end_date, this.props.date_format)}</p>
                  </div>
                </div>
                :
                <div className="col-md-2">
                  <div className="form-group">
                    <label>{I18n.t('default_range')}</label>
                    <p>{I18n.t(this.props.report_details.x_range)}</p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
    );
  };

  renderYaxisDetails() {
    return(
      <div className="panel">
        <div className="panel-default container">
          <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: '10px', paddingTop: '0px', paddingLeft: '0px', marginTop: '0px', marginBottom: '10px' }}>{I18n.t('vertical_axis_details')}</h5>
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label>{I18n.t('label')}</label>
                  <p>{this.props.report_details.y_label}</p>
                </div>
              </div>
              {
                this.props.report_details.data_details.length
                ?
                <div className="col-md-8">
                  <label>{I18n.t('data_sources_name_type')}</label>
                  <div className="form-group">
                    <ul className="y-details-list" >{this.props.report_details.data_details.filter(detail => detail.chart_element === 'y-axis').map(detail => <li className="flexed" key={detail.data_column_name} style={{ marginTop: '5px' }} >{detail.data_source.system_data ? I18n.t(detail.data_source.name) : detail.data_source.name}/{detail.data_column_name.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}/{detail.data_type.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}<div style={{marginLeft: '1rem'}} >{<Colorpicker pullRight={true} name={detail.data_column_name} color={detail.color} read_only={true} />}</div></li>)}</ul>
                  </div>
                </div>
                :
                null
              }
            </div>
          </div>
        </div>
    );
  };


};

